import { faqPagesBodySchema } from "@redotech/redo-model/faq/faq-body-schema";
import * as z from "zod/v4";

export const getFaqPages = {
  name: "getFaqPages" as const,
  input: z.object({}),
  output: z.object({ pages: z.array(faqPagesBodySchema) }),
};
